import { c as _c } from "react-compiler-runtime";
import { useCallback, useContext } from 'react';
import { APP_NAME, COMMENTS_FILTER, CTA_URL, HIDE_EMBEDDED_COMMENTS, IS_COMMENT_MODE_ACTIVE, IS_EMBEDDED_COMMENTS_ENABLED, IS_OPEN, MODULES_WITH_REPLIES, OBJECT_ID, OBJECT_TYPE, TAB, COMMENT_THREAD, ENABLED_FEATURES, IS_EMBEDDED_POPOVER_OPEN, EMBEDDED_POPOVER_PLACEMENT, EMBEDDED_COMMENT_COORDINATES, EMBEDDED_MODULE_ID, EMBEDDED_META_DESCRIPTION, IS_EMBEDDED_OPEN_FROM_COMMENT_MODE, COMMENTABLE_AREA_CLICK_COORDINATES, DELETE_COMMENT_REQUEST, EMBEDDED_POPOVER_ANCHOR_SELECTOR } from '../constants/CollaborationSidebarStateProperties';
import CollaborationSidebarStateContext from '../contexts/CollaborationSidebarStateContext';
import { getSanitizedTab } from '../utils/tab';
import { deleteCommentOnModuleAction, getEmptyCollaborationSidebarStateContext } from '../utils';
export default function useCollaborationSidebarState(t0) {
  "use memo";

  const $ = _c(57);
  const {
    allowNoContext
  } = t0 === undefined ? {} : t0;
  const contextVal = useContext(CollaborationSidebarStateContext);
  if (!contextVal && !allowNoContext) {
    throw new Error("Using useCollaborationSidebarState outside of a CollaborationSidebarStateContext");
  }
  let t1;
  if ($[0] !== contextVal) {
    t1 = contextVal || getEmptyCollaborationSidebarStateContext();
    $[0] = contextVal;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    collaborationSidebarState,
    onUpdateCollaborationSidebarState
  } = t1;
  const t2 = collaborationSidebarState[APP_NAME];
  const t3 = collaborationSidebarState[ENABLED_FEATURES];
  const t4 = collaborationSidebarState[OBJECT_TYPE];
  const t5 = collaborationSidebarState[OBJECT_ID];
  const t6 = collaborationSidebarState[CTA_URL];
  const t7 = collaborationSidebarState[IS_EMBEDDED_COMMENTS_ENABLED];
  const t8 = collaborationSidebarState[IS_OPEN];
  const t9 = collaborationSidebarState[TAB];
  const t10 = collaborationSidebarState[MODULES_WITH_REPLIES];
  const t11 = collaborationSidebarState[IS_COMMENT_MODE_ACTIVE];
  const t12 = collaborationSidebarState[HIDE_EMBEDDED_COMMENTS];
  const t13 = collaborationSidebarState[COMMENT_THREAD];
  const t14 = collaborationSidebarState[COMMENTS_FILTER];
  const t15 = collaborationSidebarState[IS_EMBEDDED_POPOVER_OPEN];
  const t16 = collaborationSidebarState[EMBEDDED_POPOVER_PLACEMENT];
  const t17 = collaborationSidebarState[EMBEDDED_COMMENT_COORDINATES];
  const t18 = collaborationSidebarState[EMBEDDED_MODULE_ID];
  const t19 = collaborationSidebarState[EMBEDDED_POPOVER_ANCHOR_SELECTOR];
  const t20 = collaborationSidebarState[EMBEDDED_META_DESCRIPTION];
  const t21 = collaborationSidebarState[IS_EMBEDDED_OPEN_FROM_COMMENT_MODE];
  const t22 = collaborationSidebarState[COMMENTABLE_AREA_CLICK_COORDINATES];
  const t23 = collaborationSidebarState[DELETE_COMMENT_REQUEST];
  let t24;
  if ($[2] !== onUpdateCollaborationSidebarState) {
    t24 = tab => onUpdateCollaborationSidebarState({
      [IS_OPEN]: true,
      [TAB]: getSanitizedTab(tab)
    });
    $[2] = onUpdateCollaborationSidebarState;
    $[3] = t24;
  } else {
    t24 = $[3];
  }
  const t25 = t24;
  let t26;
  if ($[4] !== onUpdateCollaborationSidebarState) {
    t26 = t27 => {
      const {
        isCommentModeActive,
        commentThread,
        ctaCommentId,
        SELECTED_ASSET,
        commentsFilter
      } = t27 === undefined ? {} : t27;
      return onUpdateCollaborationSidebarState({
        isOpen: true,
        tab: "comments",
        isCommentModeActive: isCommentModeActive !== null && isCommentModeActive !== void 0 ? isCommentModeActive : true,
        commentsFilter: commentsFilter !== null && commentsFilter !== void 0 ? commentsFilter : "open",
        commentThread: commentThread !== null && commentThread !== void 0 ? commentThread : undefined,
        ctaCommentId: ctaCommentId !== null && ctaCommentId !== void 0 ? ctaCommentId : undefined,
        SELECTED_ASSET: SELECTED_ASSET !== null && SELECTED_ASSET !== void 0 ? SELECTED_ASSET : undefined
      });
    };
    $[4] = onUpdateCollaborationSidebarState;
    $[5] = t26;
  } else {
    t26 = $[5];
  }
  const t27 = t26;
  let t28;
  if ($[6] !== onUpdateCollaborationSidebarState) {
    t28 = () => onUpdateCollaborationSidebarState({
      isOpen: true,
      tab: "tasks",
      isCommentModeActive: false
    });
    $[6] = onUpdateCollaborationSidebarState;
    $[7] = t28;
  } else {
    t28 = $[7];
  }
  const t29 = t28;
  let t30;
  if ($[8] !== onUpdateCollaborationSidebarState) {
    t30 = () => onUpdateCollaborationSidebarState({
      isOpen: true,
      tab: "calendar",
      isCommentModeActive: false
    });
    $[8] = onUpdateCollaborationSidebarState;
    $[9] = t30;
  } else {
    t30 = $[9];
  }
  const t31 = t30;
  let t32;
  if ($[10] !== onUpdateCollaborationSidebarState) {
    t32 = () => onUpdateCollaborationSidebarState({
      isOpen: true,
      tab: "approvals",
      isCommentModeActive: false
    });
    $[10] = onUpdateCollaborationSidebarState;
    $[11] = t32;
  } else {
    t32 = $[11];
  }
  const t33 = t32;
  let t34;
  if ($[12] !== onUpdateCollaborationSidebarState) {
    t34 = () => onUpdateCollaborationSidebarState({
      isOpen: true,
      tab: "copilot",
      isCommentModeActive: false
    });
    $[12] = onUpdateCollaborationSidebarState;
    $[13] = t34;
  } else {
    t34 = $[13];
  }
  const t35 = t34;
  let t36;
  if ($[14] !== onUpdateCollaborationSidebarState) {
    t36 = () => onUpdateCollaborationSidebarState({
      isOpen: true,
      tab: "activityFeed",
      isCommentModeActive: false
    });
    $[14] = onUpdateCollaborationSidebarState;
    $[15] = t36;
  } else {
    t36 = $[15];
  }
  const t37 = t36;
  let t38;
  if ($[16] !== onUpdateCollaborationSidebarState) {
    t38 = t39 => {
      const {
        disableCommentMode
      } = t39 === undefined ? {} : t39;
      return onUpdateCollaborationSidebarState(Object.assign({
        [IS_OPEN]: false
      }, disableCommentMode !== undefined ? {
        isCommentModeActive: !disableCommentMode
      } : {}));
    };
    $[16] = onUpdateCollaborationSidebarState;
    $[17] = t38;
  } else {
    t38 = $[17];
  }
  const t39 = t38;
  let t40;
  if ($[18] !== onUpdateCollaborationSidebarState) {
    t40 = hideEmbeddedComments => onUpdateCollaborationSidebarState({
      [HIDE_EMBEDDED_COMMENTS]: hideEmbeddedComments
    });
    $[18] = onUpdateCollaborationSidebarState;
    $[19] = t40;
  } else {
    t40 = $[19];
  }
  const t41 = t40;
  let t42;
  if ($[20] !== onUpdateCollaborationSidebarState) {
    t42 = moduleId => {
      onUpdateCollaborationSidebarState(deleteCommentOnModuleAction(moduleId));
    };
    $[20] = onUpdateCollaborationSidebarState;
    $[21] = t42;
  } else {
    t42 = $[21];
  }
  const t43 = t42;
  let t44;
  if ($[22] !== collaborationSidebarState || $[23] !== onUpdateCollaborationSidebarState || $[24] !== t10 || $[25] !== t11 || $[26] !== t12 || $[27] !== t13 || $[28] !== t14 || $[29] !== t15 || $[30] !== t16 || $[31] !== t17 || $[32] !== t18 || $[33] !== t19 || $[34] !== t2 || $[35] !== t20 || $[36] !== t21 || $[37] !== t22 || $[38] !== t23 || $[39] !== t25 || $[40] !== t27 || $[41] !== t29 || $[42] !== t3 || $[43] !== t31 || $[44] !== t33 || $[45] !== t35 || $[46] !== t37 || $[47] !== t39 || $[48] !== t4 || $[49] !== t41 || $[50] !== t43 || $[51] !== t5 || $[52] !== t6 || $[53] !== t7 || $[54] !== t8 || $[55] !== t9) {
    t44 = {
      collaborationSidebarState,
      onUpdateCollaborationSidebarState,
      appName: t2,
      enabledFeatures: t3,
      objectType: t4,
      objectId: t5,
      ctaUrl: t6,
      isEmbeddedCommentingEnabled: t7,
      isOpen: t8,
      tab: t9,
      modulesWithReplies: t10,
      replyCounts: collaborationSidebarState.replyCounts,
      isCommentModeActive: t11,
      hideEmbeddedComments: t12,
      selectedChildAsset: collaborationSidebarState.SELECTED_ASSET,
      commentThread: t13,
      commentsFilter: t14,
      isEmbeddedPopoverOpen: t15,
      embeddedPopoverPlacement: t16,
      embeddedCommentCoordinates: t17,
      embeddedModuleID: t18,
      embeddedPopoverAnchorSelector: t19,
      embeddedMetaDescription: t20,
      isEmbeddedOpenFromCommentMode: t21,
      commentableAreaClickCoordinates: t22,
      deleteCommentRequest: t23,
      openSidebar: t25,
      openComments: t27,
      openTasks: t29,
      openCalendar: t31,
      openApprovals: t33,
      openCopilot: t35,
      openActivityFeed: t37,
      closeSidebar: t39,
      setHideEmbeddedComments: t41,
      deleteCommentOnModule: t43
    };
    $[22] = collaborationSidebarState;
    $[23] = onUpdateCollaborationSidebarState;
    $[24] = t10;
    $[25] = t11;
    $[26] = t12;
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
    $[30] = t16;
    $[31] = t17;
    $[32] = t18;
    $[33] = t19;
    $[34] = t2;
    $[35] = t20;
    $[36] = t21;
    $[37] = t22;
    $[38] = t23;
    $[39] = t25;
    $[40] = t27;
    $[41] = t29;
    $[42] = t3;
    $[43] = t31;
    $[44] = t33;
    $[45] = t35;
    $[46] = t37;
    $[47] = t39;
    $[48] = t4;
    $[49] = t41;
    $[50] = t43;
    $[51] = t5;
    $[52] = t6;
    $[53] = t7;
    $[54] = t8;
    $[55] = t9;
    $[56] = t44;
  } else {
    t44 = $[56];
  }
  return t44;
}